export default "__VITE_ASSET__2QZRbbqF__"